import { Form, FormProps } from 'antd'
import { handleResError } from 'shared/helpers/handleResponseError'
import clsx from 'shared/libs/clsx'
import { RouterPages } from 'shared/model/routes'

import { useState } from 'react'

import { Navigate, Outlet, useNavigate } from 'react-router-dom'

import { useLoginMutation } from 'modules/Auth/services/authApi'
import { AuthFormState } from 'modules/Auth/types/formState'
import { ButtonContinue } from 'modules/Auth/ui/ButtonContinue'

import { useAppSelector } from 'shared/config/redux/hooks/useRedux'
import { getUserData } from 'shared/config/redux/slices/auth/selectors'

export function Auth() {
  const user = useAppSelector(getUserData)
  const { orders } = RouterPages
  const navigate = useNavigate()

  const [form] = Form.useForm<AuthFormState>()

  const [serverError, setServerError] = useState<string | null>(null)

  const [login, { isLoading }] = useLoginMutation()

  const onFinish: FormProps<AuthFormState>['onFinish'] = async (data) => {
    try {
      await login(data).unwrap()
      setServerError(null)
      navigate(orders)
    } catch (err: any) {
      const error = handleResError(err)
      setServerError(error)
    }
  }

  if (user) {
    return <Navigate to={RouterPages.orders} />
  }

  return (
    <Form
      className="h-screen flex w-full items-center justify-center bg-light_gray_2"
      form={form}
      name="auth"
      onFinish={onFinish}
      autoComplete="off"
    >
      <div className="w-full max-w-[424px] p-[32px] rounded-[16px] bg-white border border-white">
        <Outlet />
        <span
          className={clsx(
            'flex text-red_3 text-[14px] leading-[16px] transition-[margin-top] duration-[0.2s] ease-[ease-in-out]',
            { ['mt-[12px]']: serverError },
          )}
        >
          {serverError}
        </span>
        <ButtonContinue
          isLoading={isLoading}
          htmlType="submit"
          className="w-full mt-[14px]"
        />
      </div>
    </Form>
  )
}
